import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { MessageBarBody, MessageBarTitle } from '@fluentui/react-components';
import { GuideDrawer } from '../../../theme/components/GuideDrawer';
import { GuideMessageBar } from '../../../theme/components/GuideMessageBar';
import { useTranslation } from 'react-i18next';
import * as ComponentFunctions from './Protocol.ExportDerivedPatients.Form.Functions';
import { DateTimeInput } from '../../../commons/component/Inputs/DateTimeInput/DateTimeInput';

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const ProtocolExportDerivedPatientsFormComponentCode = (props: ComponentFunctions.Props & DrawerProps) => {
  const [t] = useTranslation();
  const [dateFrom, setDateFrom] = useState<Date | undefined>(undefined);
  const [dateTo, setDateTo] = useState<Date | undefined>(undefined);

  // Auto-download when the blob is ready and close the drawer
  useEffect(() => {
    if (props.FileBlob) {
      downloadFile(props.FileBlob);
      setTimeout(() => {
        props.onClose();
      }, 500);
    }
  }, [props.FileBlob]);

  const downloadFile = (blob: Blob) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `DerivedPatients_${Date.now()}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  };

  const handleExport = () => {
    props.ExportDerivedPatientsToExcel(undefined, dateFrom, dateTo);
  };

  const isFormValid = () => {
    return dateFrom && dateTo && dateTo >= dateFrom;
  };

  return (
    <GuideDrawer
      open={props.isOpen}
      size="small"
      title={'Exportar Pacientes Derivados'}
      onDismiss={props.onClose}
      testId="protocol-export-derived-patients-drawer"
      secondaryAction={{ label: t('protocolExportVisitForm.cancel') }}
      primaryAction={{
        label: props.isGenerating ? t('protocolExportVisitForm.generatingFile') : t('protocolExportVisitForm.exportToExcel'),
        onClick: handleExport,
        disabled: !isFormValid(),
        loading: props.isGenerating,
      }}
    >
      {props.error && (
        <GuideMessageBar intent="error">
          <MessageBarBody>
            <MessageBarTitle>{'Error al exportar'}</MessageBarTitle>
            {props.error.ErrorMessage}
          </MessageBarBody>
        </GuideMessageBar>
      )}

      <DateTimeInput
        label={t('protocolExportVisitForm.dateFrom')}
        placeHolder={t('protocolExportVisitForm.selectStartDate')}
        selectedDate={dateFrom}
        isSubmitted={false}
        isRequired={true}
        errorMessage={undefined}
        onSelectDate={setDateFrom}
      />
      <DateTimeInput
        label={t('protocolExportVisitForm.dateTo')}
        placeHolder={t('protocolExportVisitForm.selectEndDate')}
        selectedDate={dateTo}
        isSubmitted={false}
        isRequired={true}
        errorMessage={undefined}
        onSelectDate={setDateTo}
      />
    </GuideDrawer>
  );
};

export default connect(
  ComponentFunctions.mapStateToProps,
  ComponentFunctions.mapDispatchToProps
)(ProtocolExportDerivedPatientsFormComponentCode as any);
